import React, { useState } from "react";
import { useLocation,useNavigate } from "react-router";
import { Stepper,Step } from "@progress/kendo-react-layout";
import { REWARDS_CAMPAIGNS_ADD } from "../../../routes";

const items = [
    {
      label: "Campaign Info",
      value: 0,
    },    
    {
      label: "Upload Nominees List",
      value: 1,
    },        
    {
      label: "Review",
      value: 2,
    }
  ];

  const itemsPredefinedTask = [
    {
      label: "Campaign Info",
      value: 0,
    },    
    {
      label: "Rewards Configuration",
      value: 1,
    },        
    {
      label: "Review",
      value: 2,
    }
  ];

  const itemsWithoutId = [
    {
      label: "Campaign Info",
      value: 0,
    },        
    {
      label: "Review",
      value: 2,
    }
  ];

  const CustomStep = (props) => {
      return (
        <Step {...props}>
          <div className="custom-step">
            <span>{props.svgIcon}</span>
          </div>
          <span className="step-label">{props.label}</span>
        </Step>
      );
    };
export const AddCampaignSteps = (props) => {
  const navigate = useNavigate();
  let { search } = useLocation();
  const query = new URLSearchParams(search); 
  const id = query.get("id"); 
  const handleChange = (e) => {
    // e.preventDefault();
    if(e.value != 0){
      if (props.checkMandatoryFields()) return;
    }
    if(query.get("id")){
      if(props.isSplashOnly && e.value != 0){
        props.setState(e.value+1);
        query.set("state",e.value+1);
      }
      else if(isShowNominationTab()) {
        let tab = e.value > 0 && !isShowNominationTab() ? 2 : e.value
        props.setState(tab);
        query.set("state",tab);  
      } else {
        let tab = e.value > 0 && !isShowRewardConfigurationTab() ? 2 : e.value
        props.setState(tab);
        query.set("state",tab);  
      }
      navigate(REWARDS_CAMPAIGNS_ADD+"?"+query.toString());     
    }else {
      props.handleSubmit(false);
    }
  };


  const isShowRewardConfigurationTab = () => {

    let isShow = false;

    if(props.editData.type == "Predefined Task Based"){
      isShow = true;
    }
  

    return isShow;
  };

  const isShowNominationTab = () => {

    let isShow = false;

    if((props.editData.status == "Pending Nomination" || props.editData.status == "Approved") && !props.isAdmin && props.isValidator){
      isShow = true;
    }

    // if(props.editData.status == "Rejected" && props.isAdmin){
    //   isShow = true;
    // }
  

    return isShow;
  };
  
  const getIndex = () => {
    if(id && isShowNominationTab()){
      return props.state;
    }else if(isShowRewardConfigurationTab()){
      return props.state;
    }else {
      return itemsWithoutId.findIndex(x => x.value === props.state)
    }
  }

  const getList = () => {
    if(id && isShowNominationTab()){
      return items;
    }else if(isShowRewardConfigurationTab()){
      return itemsPredefinedTask;
    }else {
      return itemsWithoutId
    }
  }


  return (
    <>
        <div className="poll-progress-steps-group">
            <div className="progress-steps-inside-group">
                <Stepper 
                  className="campaigns_steps" 
                  value={getIndex()} 
                  items={getList()}
                  // item={CustomStep}
                  onChange={(e)=>handleChange(e)} 
                />
            </div>
        </div>
    </>
  );
};